import { DeleteProcessInstance } from "common/constants";
import "react-datepicker/dist/react-datepicker.css";
import { Col, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import AdvanceTableFooter from "components/common/advance-table/AdvanceTableFooter";
import AdvanceTableWrapper from "components/common/advance-table/AdvanceTableWrapper";
import IconButton from "components/common/IconButton";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { refreshWorkflowCounts } from "./WorkflowHelper";
import store from "reducers/store";
import { useNavigate, useLocation } from "react-router-dom";
import { parse } from "date-fns";
import {
	getTaskVariables,
	getExecutionLocalVariables,
	getFormById,
	executePendingTasks,
	parseQueryParams,
	getWorkflowListByGroups,
	claimTask,
	unclaimTask,
	getPendingTasks,
	fetchAndStoreDropdownData,
	getCountTaskByAssignee,
	getCountWorkflowsByGroups,
	getCountWorkflowsByUsers,
} from "./WorkflowHelper";
import * as Constants from "common/constants";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import db from "indexedDB";
import * as em from "common/ErrorMessages";
import { EncryptStorage } from "encrypt-storage";
import * as General from "common/general";
import { toast } from "react-toastify";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import LoaderIcon from "components/custom/Preloader";
import { Utils } from "formiojs";
import UpliftCss from "../common/upliftcss.module.css";
import SearchPanel from "components/common/SearchPanel";
import useWindowWidth from "components/forms/custom/WindowsSize/useWindowWidth.js";
import CustomMobileCard from "components/common/CustomMobileCard";
import BreadCrums from "components/pages/landing/BreadCrums";
import PageTitle from "components/common/PageTitle";

function GetWorkflowListByAssignee() {
	const encryptStorage1 = new EncryptStorage("secret-key-value", {
		prefix: "@mwan",
	});
	const navigate = useNavigate();

	const width = useWindowWidth();
	const isMobile = width <= 768;

	const [task_id, settask_id] = useState("");
	const [table_name, settable_name] = useState("");
	const [emanifestId, setemanifestId] = useState("");
	const [fetchFlag, setFetchFlag] = useState(false);
	const [submitted, setSubmitted] = useState(false);
	const [isRTL, setIsRTL] = useState(JSON.parse(localStorage.getItem("isRTL")) || false);
	const [showNotification, setShowNotification] = useState(false);
	const [showPreloader, setshowPreloader] = useState(false);
	const [isFinish, setIsFinish] = useState(null);

	const [serverPageSize, setServerPageSize] = useState(10);
	const [serverCurrentPage, setServerCurrentPage] = useState(1);
	const [totalRecords, setTotalRecords] = useState(0);
	const [rowCount, setRowCount] = useState(10);
	const [isDataReady, setIsDataReady] = useState(false);
	const [createdId, setCreatedId] = useState();
	const isInitialMount = useRef(true);
	const isStateRestored = useRef(false);

	const [sortField, setSortField] = useState("created");
	const [sortDirection, setSortDirection] = useState("desc");
	const lastFetchSignatureRef = useRef("");

	const [searchParams, setSearchParams] = useState({
		searchTerm: "",
		startDate: "",
		endDate: "",
	});

	const [searchValues, setSearchValues] = useState({
		searchTerm: "",
		startDate: null,
		endDate: null,
	});

	const [modal, setModal] = useState(false);
	const openModal = (id, tablename, emanifestid, createdId) => {
		setModal(!modal);
		settask_id(id);
		settable_name(tablename);
		setemanifestId(emanifestid);
		setCreatedId(createdId);
	};

	const handleServerPagination = (newPageSize) => {
		setServerPageSize(newPageSize);
		setServerCurrentPage(1);
		setFetchFlag((prev) => !prev);

		const paginationState = {
			currentPage: 1,
			pageSize: newPageSize,
			searchParams,
			totalRecords,
			sortField,
			sortDirection,
		};
		sessionStorage.setItem("workflowPaginationState", JSON.stringify(paginationState));
	};

	const handleNextPage = () => {
		const nextPage = serverCurrentPage + 1;
		setServerCurrentPage(nextPage);
		setFetchFlag((prev) => !prev);

		const paginationState = {
			currentPage: nextPage,
			pageSize: serverPageSize,
			searchParams,
			totalRecords,
			sortField,
			sortDirection,
		};
		sessionStorage.setItem("workflowPaginationState", JSON.stringify(paginationState));
	};

	const handlePreviousPage = () => {
		const prevPage = serverCurrentPage - 1;
		setServerCurrentPage(prevPage);
		setFetchFlag((prev) => !prev);

		const paginationState = {
			currentPage: prevPage,
			pageSize: serverPageSize,
			searchParams,
			totalRecords,
			sortField,
			sortDirection,
		};
		sessionStorage.setItem("workflowPaginationState", JSON.stringify(paginationState));
	};

	const handleJumpToPage = (pageNumber) => {
		setServerCurrentPage(pageNumber);
		setFetchFlag((prev) => !prev);

		const paginationState = {
			currentPage: pageNumber,
			pageSize: serverPageSize,
			searchParams,
			totalRecords,
			sortField,
			sortDirection,
		};
		sessionStorage.setItem("workflowPaginationState", JSON.stringify(paginationState));
	};

	const isUpdatingFromSort = React.useRef(false);
	useEffect(() => {
		if (isUpdatingFromSort.current) {
			isUpdatingFromSort.current = false;
			return;
		}

		const paginationState = {
			currentPage: serverCurrentPage,
			pageSize: serverPageSize,
			searchParams,
			totalRecords,
			sortField,
			sortDirection,
		};
		sessionStorage.setItem("workflowPaginationState", JSON.stringify(paginationState));
	}, [searchParams, serverCurrentPage, serverPageSize]);

	const handleSort = (column, direction) => {
		// Track previous values to prevent unnecessary updates
		const isSameSort = column === sortField && direction === sortDirection;
		// Only update if sorting has actually changed
		if (!isSameSort) {
			setSortField(column);
			setSortDirection(direction);
			setServerCurrentPage(1);

			// Save sort state to session storage
			const paginationState = {
				currentPage: 1,
				pageSize: serverPageSize,
				searchParams,
				totalRecords,
				sortField: column,
				sortDirection: direction,
			};
			sessionStorage.setItem("workflowPaginationState", JSON.stringify(paginationState));
		}
	};

	useEffect(() => {
		const paginationState = {
			currentPage: serverCurrentPage,
			pageSize: serverPageSize,
			searchParams,
			totalRecords,
		};
		sessionStorage.setItem("workflowPaginationState", JSON.stringify(paginationState));
	}, [searchParams]);

	useEffect(() => {
		const restoreState = () => {
			const returningState = sessionStorage.getItem("returningFromForm");
			if (returningState && !isStateRestored.current) {
				const paginationState = JSON.parse(returningState);

				Promise.resolve().then(() => {
					setServerCurrentPage(paginationState.currentPage);
					setServerPageSize(paginationState.pageSize);
					setSearchParams(paginationState.searchParams);
					setTotalRecords(paginationState.totalRecords);

					if (paginationState.sortField) {
						setSortField(paginationState.sortField);
					}
					if (paginationState.sortDirection) {
						setSortDirection(paginationState.sortDirection);
					}

					setSearchValues({
						searchTerm: paginationState.searchParams.searchTerm || "",
						startDate: paginationState.searchParams.startDate ? moment(paginationState.searchParams.startDate, "DD-MM-YYYY").toDate() : null,
						endDate: paginationState.searchParams.endDate ? moment(paginationState.searchParams.endDate, "DD-MM-YYYY").toDate() : null,
					});
				});

				isStateRestored.current = true;
				sessionStorage.removeItem("returningFromForm");
			}
			isInitialMount.current = false;
		};

		restoreState();
	}, []);

	useEffect(() => {
		const handleScan = async (generatedEmanifestId) => {
			var pendingTaskRecords = await db.pending_tasks.toArray();
			for (let i = 0; i < pendingTaskRecords.length; i++) {
				var pendingTask = JSON.parse(pendingTaskRecords[i].pendingTasks);
				if (pendingTask.generatedEmanifestID === generatedEmanifestId) {
					handleContinue(pendingTaskRecords[i].id);
					return;
				}
			}
			const companyId = encryptStorage1.getItem(Constants.SelectedCompany);

			const workflowList = await getWorkflowListByGroups(companyId);

			let workflows = await Promise.all(
				workflowList.workflowsByAssigneeList.map(async (workflow) => {
					workflow.taskId = workflow.id;
					const executionId = workflow.executionId;
					const tableName = workflow.processDefinition.key;
					const processInstanceId = workflow.processInstanceId;
					const taskVariables = await getTaskVariables(processInstanceId);
					let executionLocalVariables = await getExecutionLocalVariables(executionId);
					executionLocalVariables = executionLocalVariables;

					if (executionLocalVariables.gridInformation !== undefined) {
						let grid_information = "";
						for (const element of Object.values(executionLocalVariables.gridInformation.value)) {
							grid_information += ", " + element;
						}
						workflow.processInformation = grid_information;
						setProcessInformation(grid_information);
					}

					let generatedEmanifestID = taskVariables.find((variable) => variable.name === "generatedEmanifestID");
					if (generatedEmanifestID != undefined) {
						workflow.generatedEmanifestID = generatedEmanifestID.value;
					}

					return workflow;
				})
			);

			for (let i = 0; i < workflows.length; i++) {
				if (workflows[i].generatedEmanifestID === generatedEmanifestId) {
					const userInfo = encryptStorage1.getItem(Constants.LoggedInUserInfoKeyInLocalStorage);
					const loggedInUser = userInfo.userId;
					await claimTask(workflows[i].taskId, loggedInUser);
					setIsFinish(true);
					setFetchFlag(true);
					return;
				}
			}
		};
		if (!isFinish && isFinish !== null) {
			const currentUrl = window.location.href;

			var queryParams = parseQueryParams(currentUrl);

			if (queryParams.generatedEmanifestId) {
				handleScan(queryParams.generatedEmanifestId);
				//handleContinue();
			}
		}
	}, [isFinish]);

	useEffect(() => {
		const handleContinueWorkflowStep = async (currentStep) => {
			var current_workflow_step = await db.current_workflow_step.toArray();
			if (current_workflow_step.length > 0) {
				currentStep = JSON.parse(current_workflow_step[0].currentWorkflowStep);
			}
			var pendingTaskRecords = await db.pending_tasks.toArray();
			sessionStorage.setItem(Constants.HasRedirected, true);
			for (let i = 0; i < pendingTaskRecords.length; i++) {
				var pendingTask = JSON.parse(pendingTaskRecords[i].pendingTasks);
				var generatedEmanifestID = null;
				if (currentStep.generatedEmanifestID) {
					// if (currentStep.taskVariables.find((variable) => variable.name === "generatedEmanifestID") !== undefined) {
					generatedEmanifestID = currentStep.generatedEmanifestID;
					if (pendingTask.generatedEmanifestID === generatedEmanifestID && generatedEmanifestID) {
						await db.table("current_workflow_step").clear();
						localStorage.removeItem(Constants.CurrentWorkflowStep);
						handleContinue(pendingTaskRecords[i].id);
						break;
					}
					// }
				}
			}
			await db.table("current_workflow_step").clear();
			localStorage.removeItem(Constants.CurrentWorkflowStep);
		};

		const currentUrl = window.location.href;

		var queryParams = parseQueryParams(currentUrl);
		if (!isFinish && isFinish !== null && !queryParams.generatedEmanifestId) {
			const currentStep = localStorage.getItem(Constants.CurrentWorkflowStep);
			const hasRedirected = sessionStorage.getItem(Constants.HasRedirected);
			if (currentStep && hasRedirected === null) {
				handleContinueWorkflowStep(JSON.parse(currentStep));
			}
		}
	}, [isFinish]);

	const handleDelete = async () => {
		setModal(!modal);
		try {
			var accessToken = encryptStorage1.getItem(Constants.AccessTokenKeyInLocalStorage);
			const response = await fetch(DeleteProcessInstance + task_id, {
				method: "DELETE",
				headers: {
					"Content-Type": "application/json",
				...(accessToken && { Authorization: "Bearer " + accessToken }),
				},
			});
			const data = await response.json();

			if (data.status === 1) {
				if (createdId != null && createdId != "") {
					const jsonRequest = {
						databasePutData: {
							itemFieldName: "id",
							itemId: createdId,
							tableName: table_name,
							fields: {
								taskStatus: "Deleted",
							},
						},
					};

					General.PatchToEndPoint(Constants.PatchEndPoint, null, JSON.stringify(jsonRequest));
				}

				// Always refresh list after successful delete
				setFetchFlag((prev) => !prev);
				await refreshWorkflowCounts();
				toast.success(t(em.deleted_successfully));
			} else {
				toast.error(t(em.failed_delete_workflow));
			}
		} catch (err) {
			console.error(err.message);
			toast.error(t(em.failed_delete_workflow));
		}
	};

	const updateCounters = async () => {
		try {
			const userInfo = encryptStorage1.getItem(Constants.LoggedInUserInfoKeyInLocalStorage);
			const companyId = encryptStorage1.getItem(Constants.SelectedCompany);
			const loggedInUser = userInfo.userId;

			// Update pending tasks counter
			const pendingCount = await getCountTaskByAssignee(loggedInUser);
			store.dispatch({ type: SET_COUNT, payload: { data: pendingCount.count } });

			// Update unassigned tasks counter
			const [groupCount, userCount] = await Promise.all([getCountWorkflowsByGroups(companyId), getCountWorkflowsByUsers(loggedInUser)]);
			const totalUnassigned = (groupCount.count || 0) + (userCount.count || 0);
			store.dispatch({ type: SET_COUNT_UNASSIGNED, payload: { data: totalUnassigned } });
		} catch (error) {
			console.error("Error updating counters:", error);
		}
	};

	const openModalUnclaim = (parsedTask) => {
		setModalUnClaim(true);
		settask_id(parsedTask.id);
		console.log({task_id});
		settable_name(parsedTask.tablename);
		setemanifestId(parsedTask.generatedEmanifestID);
		setCreatedId(parsedTask.createdId)
	};

	const handleUnclaim = async () => {
		try {
			const userInfo = encryptStorage1.getItem(Constants.LoggedInUserInfoKeyInLocalStorage);
			const loggedInUser = userInfo.userId;

			const result = await unclaimTask(task_id, loggedInUser);

			if (result.status === 1) {
				setModalUnClaim(false);
				toast.success(t("Task unclaimed successfully"));
				setFetchFlag((prev) => !prev); // Refresh the list
				await updateCounters(); // Update menu counters
			} else {
				toast.error(t("Failed to unclaim task"));
			}
		} catch (error) {
			console.error("Error unclaiming task:", error);
			toast.error(t("Failed to unclaim task"));
		}
	};

	const toggle = () => setModal(!modal);
	const [workflows, setWorkflows] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [originalData, setOriginalData] = useState([]);
	const [processInformation, setProcessInformation] = useState("");
	const [t, i18n] = useTranslation();
	const location = useLocation();
	const menuName = t(location?.state?.pagename) || t(em.pending_task);
	// add table headers and accessor is the name of the field in the json
	const parseDate = (dateString) => parse(dateString, "dd-MM-yyyy HH:mm:ss", new Date());
	const [modalUnClaim, setModalUnClaim] = useState(false);
	const toggleUnClaim = () => setModalUnClaim(!modalUnClaim);

	const columns = [
		{
			accessor: "generatedEmanifestID",
			Header: t("Process ID"),
			isTop: true,
			showMobile: true,
		},
		{
			accessor: "name",
			Header: t("Process Name"),
			isTop: false,
			showMobile: false,
		},
		{
			accessor: "taskName",
			Header: t("User Task Name"),
			isTop: false,
			showMobile: false,
		},
		{
			accessor: "facilityName",
			Header: t("Facility Name"),
			isTop: false,
			showMobile: true,
		},
		{
			accessor: "status",
			Header: t("Status"),
			isTop: true,
			showMobile: true,
		},
		{
			accessor: "created",
			Header: t("Creation Date"),
			type: "date",
			sortType: (rowA, rowB) => {
				const dateA = parseDate(rowA.values.created);
				const dateB = parseDate(rowB.values.created);
				return dateA - dateB;
			},
			isTop: false,
			showMobile: true,
		},
		{
			accessor: "action",
			Header: t("Action"),
			disableSortBy: true,
			isTop: false,
			showMobile: false,
		},
	];
	const [startDateFilter, setStartDateFilter] = useState();
	const [endDateFilter, setEndDateFilter] = useState();

	const filterdata = (data) => {
		let filter = [];
		data.map((workflow) => {
			const searchgeneratedEmanifestID = t(workflow.generatedEmanifestID);
			const searchname = t(workflow.name);
			const searchtaskName = t(workflow.taskName);
			if (startDateFilter && endDateFilter) {
				if (moment(workflow.created, "DD-MM-YYYY").isBetween(moment(startDateFilter, "DD-MM-YYYY"), moment(endDateFilter, "DD-MM-YYYY"), null, "[]")) {
					filter.push(workflow);
				}
			} else if (startDateFilter && !endDateFilter) {
				if (moment(workflow.created, "DD-MM-YYYY").isSameOrAfter(moment(startDateFilter, "DD-MM-YYYY"))) {
					filter.push(workflow);
				}
			} else if (!startDateFilter && endDateFilter) {
				if (moment(workflow.created, "DD-MM-YYYY").isSameOrBefore(moment(endDateFilter, "DD-MM-YYYY"))) {
					filter.push(workflow);
				}
			} else {
				filter.push(workflow);
			}
		});

		return filter;
	};

	useEffect(() => {
		let NewData = filterdata(originalData);
		setTableData(NewData);
		setWorkflows(NewData);
	}, [startDateFilter, endDateFilter]);

	const handleTableErrors = async () => {
		try {
			await Promise.all([
				db.table("submission_data").clear(),
				// db.table("temp_form_data").clear(),
				db.table("pending_tasks").clear(),
			]);
			//window.location.reload();
		} catch (error) {
			console.error("Failed to clear tables:", error);
		}
	};

	useEffect(() => {
		async function fetchData() {
			if (isInitialMount.current || isStateRestored.current) {
				isStateRestored.current = false;
				return;
			}

			const fetchSignature = `${serverCurrentPage}-${serverPageSize}-${JSON.stringify(searchParams)}-${sortField}-${sortDirection}-${fetchFlag}`;
			if (fetchSignature === lastFetchSignatureRef.current) {
				return;
			}
			lastFetchSignatureRef.current = fetchSignature;

			try {
				setIsDataReady(false);
				setIsFinish(true);
				if (!navigator.onLine) {
					setIsDataReady(true);
					var submissionData = await db.submission_data.toArray();
					var pendingTasks = await db.pending_tasks.toArray();
					for (let i = 0; i < submissionData.length; i++) {
						var index = JSON.parse(submissionData[i].submissionData).index;
						if (index !== undefined) {
							for (let j = 0; j < pendingTasks.length; j++) {
								if (pendingTasks[j].id === parseInt(index, 10)) {
									const parsedPendingTasks = JSON.parse(pendingTasks[j].pendingTasks);
									parsedPendingTasks.name += ":OFFLINE-EXECUTED";
									pendingTasks[j].pendingTasks = JSON.stringify(parsedPendingTasks);
								}
							}
						}
					}
					pendingTasks = pendingTasks.flatMap((task) => {
						const parsedTask = JSON.parse(task.pendingTasks);
						parsedTask.created = parsedTask.created;
						parsedTask.taskName = parsedTask.name ? t(parsedTask.name) : "";
						// If task name is "Schedule Inspection Visits", remove "facility_name:" from processInformation
						if (parsedTask.taskName === "Schedule Inspection Visits" && parsedTask.processInformation) {
							parsedTask.processInformation = parsedTask.processInformation.replace('"facility_name":', "");
						}
						parsedTask.name = t(parsedTask.processDefinition.name) + (parsedTask.processInformation ? t(parsedTask.processInformation) : "");
						parsedTask.index = task.id;
						parsedTask.status = t(parsedTask?.workflowStatus?.label);

						var styleString = "";
						if (isRTL) {
							styleString = parsedTask?.workflowStatus?.css_ar;
						} else {
							styleString = parsedTask?.workflowStatus?.css;
						}
						parsedTask.rowStyle = styleString
							? Object.fromEntries(
									styleString
										.split(/;(?![^(]*\))/)
										.map((s) => s.trim())
										.filter(Boolean)
										.map((rule) => {
											const [property, value] = rule.split(/:(.+)/); // split at first colon only
											const camelProp = property.trim().replace(/-([a-z])/g, (_, c) => c.toUpperCase());
											return [camelProp, value.trim()];
										})
							  )
							: undefined;
						parsedTask.action = (
							<>
								{!parsedTask?.name.includes("OFFLINE") && (
									<OverlayTrigger
										overlay={
											<Tooltip style={{ position: "fixed" }} id="idsubmit">
												{t(em.execute_task)}
											</Tooltip>
										}
									>
										<div className="theme-control-toggle-label icon-position">
											<IconButton
												className={`play-hover  ${UpliftCss.forceButtonColorwhite}`}
												iconClassName="fs--2"
												variant="falcon-default"
												size="sm"
												icon="fa fa-play"
												style={{
													margin: "auto 0.25rem",
													backgroundColor: "#00a862",
													borderColor: "#00a862",
												}}
												onClick={() => handleContinue(parsedTask.index)}
											></IconButton>
										</div>
									</OverlayTrigger>
								)}
								{parsedTask.formData?.hyperLinkVariables && (
									<OverlayTrigger
										overlay={
											<Tooltip style={{ position: "fixed" }} id="idviewsummary">
												{t("View Summary")}
											</Tooltip>
										}
									>
										<div className="theme-control-toggle-label icon-position">
											<IconButton
												className={`play-hover  ${UpliftCss.forceButtonColorwhite}`}
												iconClassName="fs--2"
												variant="falcon-default"
												size="sm"
												icon="fa-solid fa-eye"
												style={{
													margin: "auto 0.25rem",
													backgroundColor: "#00a862",
													borderColor: "#00a862",
												}}
												onClick={() => viewSummary(parsedTask.index)}
											></IconButton>
										</div>
									</OverlayTrigger>
								)}

								{parsedTask !== null && parsedTask?.renderId && (
									<OverlayTrigger
										overlay={
											<Tooltip style={{ position: "fixed" }} id="DownloadPdfTooltip">
												{t("Download PDF")}
											</Tooltip>
										}
									>
										<div className="theme-control-toggle-label icon-position end-text">
											<IconButton
												className={`btn btn-primary  ${UpliftCss.forceButtonColorwhite}`}
												iconClassName="fs--2"
												variant=""
												size="sm"
												icon="fa-solid fa-download"
												style={{ margin: "auto 0.25rem" }}
												onClick={() => downloadPdf(renderId)}
											></IconButton>
										</div>
									</OverlayTrigger>
								)}

								{parsedTask !== null && parsedTask.ableToDelete !== "false" && parsedTask.enableDelete && (
									<OverlayTrigger
										overlay={
											<Tooltip style={{ position: "fixed" }} id="abletodelete">
												{t(em.delete_icon)}
											</Tooltip>
										}
									>
										<div className="theme-control-toggle-label icon-position">
											<IconButton
												className="btn btn-danger"
												iconClassName="fs--2"
												variant=""
												size="sm"
												icon="fa-solid fa-trash"
												style={{ margin: "auto 0.25rem" }}
												onClick={() => openModal(parsedTask.processInstanceId, parsedTask.processDefinition.key, parsedTask.generatedEmanifestID, parsedTask?.createdId)}
											></IconButton>
										</div>
									</OverlayTrigger>
								)}

								{parsedTask?.canUnclaim && (
									<OverlayTrigger
										overlay={
											<Tooltip style={{ position: "fixed" }} id="unclaimtooltip">
												{t("Unclaim Task")}
											</Tooltip>
										}
									>
										<div className="theme-control-toggle-label icon-position">
											<IconButton
												className="btn btn-warning"
												iconClassName="fs--2"
												variant=""
												size="sm"
												icon="fa-solid fa-unlock"
												style={{ margin: "auto 0.25rem" }}
												onClick={() =>  openModalUnclaim(parsedTask)}	
											></IconButton>
										</div>
									</OverlayTrigger>
								)}
							</>
						);
						return parsedTask;
					});

					setOriginalData(pendingTasks);
					setTableData(pendingTasks);
					setWorkflows(pendingTasks);
					setIsFinish(false);
				} else {
					// const delay1 = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
					// await delay1(2000);
					const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

					await executePendingTasks(setSubmitted, setshowPreloader, setShowNotification, navigate, location, t);
					await delay(100);
					var pendingTasks1 = await db.pending_tasks.toArray();
					var indexDbPendingIds = [];
					for (let j = 0; j < pendingTasks1.length; j++) {
						indexDbPendingIds.push(JSON.parse(pendingTasks1[j].pendingTasks).id);
					}

					// await Promise.all([db.table("submission_data").clear(), db.table("pending_tasks").clear()]);
					await Promise.all([db.table("submission_data").clear()]);

					const userInfo = encryptStorage1.getItem(Constants.LoggedInUserInfoKeyInLocalStorage);
					const loggedInUser = userInfo.userId;

					const workflowList = await getPendingTasks(
						loggedInUser,
						indexDbPendingIds,
						serverCurrentPage,
						serverPageSize,
						searchParams.searchTerm,
						searchParams.startDate,
						searchParams.endDate,
						sortField,
						sortDirection
					);

					const totalCount = workflowList?.totalCount || 0;
					if (totalCount == 0) {
						setTotalRecords(0);
						setRowCount(0);

						setTableData([]);
						setIsDataReady(true);
						setIsFinish(false);
						return;
					}

					setTotalRecords(totalCount);

					await Promise.all([db.table("pending_tasks").clear(), db.table("dropdown_data").clear()]);

					let requestUrls = [];
					for (let i = 0; i < workflowList.lPendingTaskResponseDTO.length; i++) {
						const jsonString = JSON.stringify(workflowList.lPendingTaskResponseDTO[i]);
						let components = JSON.parse(jsonString).formData.components;
						Utils.eachComponent(
							components,
							function (component) {
								if (component.input) {
									if (component.type === "dropdownCustomComp") {
										if (component.requestUrl && !requestUrls.includes(component.requestUrl)) {
											requestUrls.push(component.requestUrl);
										}
									}
								} else if (component.type === "columns") {
									Utils.eachComponent(
										component.columns,
										function (component2) {
											if (component2.type === "dropdownCustomComp") {
												if (component2.requestUrl && !requestUrls.includes(component2.requestUrl)) {
													requestUrls.push(component2.requestUrl);
												}
											}
										},
										true
									);
								}
							},
							true
						);
						await db.pending_tasks.add({ pendingTasks: jsonString });
					}

					await Promise.all(requestUrls.map((url) => fetchAndStoreDropdownData(url)));
					const pendingTasks = await db.pending_tasks.toArray();

					if ("serviceWorker" in navigator) {
						const registration = await navigator.serviceWorker.ready;
						registration.active.postMessage({
							action: "deleteFromCache",
							pattern: "/form_view_renderer",
						});

						for (const task of pendingTasks) {
							registration.active.postMessage({
								action: "cachePage",
								url: "/form_view_renderer?index=" + task.id,
							});
						}
					}

					const pendingTasks2 = pendingTasks.flatMap((task) => {
						const parsedTask = JSON.parse(task.pendingTasks);

						parsedTask.created = parsedTask.created;
						parsedTask.taskName = parsedTask.name ? t(parsedTask.name) : "";
						// If task name is "Schedule Inspection Visits", remove "facility_name:" from processInformation
						if (parsedTask.processDefinition.name === "Schedule Inspection Visits" && parsedTask.processInformation) {
							parsedTask.processInformation = parsedTask.processInformation.replace('"facility_name":', "");
						}
						parsedTask.name = t(parsedTask.processDefinition.name) + (parsedTask.processInformation ? t(parsedTask.processInformation) : "");
						parsedTask.index = task.id;
						parsedTask.status = t(parsedTask?.workflowStatus?.label);

						var styleString = "";
						if (isRTL) {
							styleString = parsedTask?.workflowStatus?.css_ar;
						} else {
							styleString = parsedTask?.workflowStatus?.css;
						}
						parsedTask.rowStyle = styleString
							? Object.fromEntries(
									styleString
										.split(/;(?![^(]*\))/)
										.map((s) => s.trim())
										.filter(Boolean)
										.map((rule) => {
											const [property, value] = rule.split(/:(.+)/); // split at first colon only
											const camelProp = property.trim().replace(/-([a-z])/g, (_, c) => c.toUpperCase());
											return [camelProp, value.trim()];
										})
							  )
							: undefined;

						parsedTask.action = (
							<>
								{!parsedTask?.name.includes("OFFLINE") && (
									<OverlayTrigger
										overlay={
											<Tooltip style={{ position: "fixed" }} id="idsubmit">
												{t(em.execute_task)}
											</Tooltip>
										}
									>
										<div className="theme-control-toggle-label icon-position">
											<IconButton
												className={`play-hover  ${UpliftCss.forceButtonColorwhite}`}
												iconClassName="fs--2"
												variant="falcon-default"
												size="sm"
												icon="fa fa-play"
												style={{
													margin: "auto 0.25rem",
													backgroundColor: "#00a862",
													borderColor: "#00a862",
												}}
												onClick={() => handleContinue(parsedTask.index)}
											></IconButton>
										</div>
									</OverlayTrigger>
								)}
								{parsedTask.formData?.hyperLinkVariables && (
									<OverlayTrigger
										overlay={
											<Tooltip style={{ position: "fixed" }} id="idviewsummary">
												{t("View Summary")}
											</Tooltip>
										}
									>
										<div className="theme-control-toggle-label icon-position">
											<IconButton
												className={`play-hover  ${UpliftCss.forceButtonColorwhite}`}
												iconClassName="fs--2"
												variant="falcon-default"
												size="sm"
												icon="fa-solid fa-eye"
												style={{
													margin: "auto 0.25rem",
													backgroundColor: "#00a862",
													borderColor: "#00a862",
												}}
												onClick={() => viewSummary(parsedTask.index)}
											></IconButton>
										</div>
									</OverlayTrigger>
								)}

								{parsedTask !== null && parsedTask?.formData?.renderId && (
									<OverlayTrigger
										overlay={
											<Tooltip style={{ position: "fixed" }} id="DownloadPdfTooltip">
												{t("Download PDF")}
											</Tooltip>
										}
									>
										<div className="theme-control-toggle-label icon-position end-text">
											<IconButton
												className={`btn btn-primary  ${UpliftCss.forceButtonColorwhite}`}
												iconClassName="fs--2"
												variant=""
												size="sm"
												icon="fa-solid fa-download"
												style={{ margin: "auto 0.25rem" }}
												onClick={() => downloadPdf(parsedTask?.formData?.renderId)}
											></IconButton>
										</div>
									</OverlayTrigger>
								)}

								{parsedTask !== null && parsedTask.ableToDelete !== "false" && parsedTask.enableDelete && (
									<OverlayTrigger
										overlay={
											<Tooltip style={{ position: "fixed" }} id="abletodelete">
												{t(em.delete_icon)}
											</Tooltip>
										}
									>
										<div className="theme-control-toggle-label icon-position">
											<IconButton
												className="btn btn-danger"
												iconClassName="fs--2"
												variant=""
												size="sm"
												icon="fa-solid fa-trash"
												style={{ margin: "auto 0.25rem" }}
												onClick={() => openModal(parsedTask.processInstanceId, parsedTask.processDefinition.key, parsedTask.generatedEmanifestID, parsedTask?.createdId)}
											></IconButton>
										</div>
									</OverlayTrigger>
								)}

								{parsedTask?.canUnclaim && (
									<OverlayTrigger
										overlay={
											<Tooltip style={{ position: "fixed" }} id="unclaimtooltip">
												{t("Unclaim Task")}
											</Tooltip>
										}
									>
										<div className="theme-control-toggle-label icon-position">
											<IconButton
												className="btn btn-warning"
												iconClassName="fs--2"
												variant=""
												size="sm"
												icon="fa-solid fa-unlock"
												style={{ margin: "auto 0.25rem" }}
												onClick={() =>  openModalUnclaim(parsedTask)}
											></IconButton>
										</div>
									</OverlayTrigger>
								)}
							</>
						);
						return parsedTask;
					});

					if (!originalData || originalData.length === 0) {
						setOriginalData(pendingTasks2);
					}

					const recordsPerPage = pendingTasks2?.length;
					setRowCount(recordsPerPage);

					setTableData(pendingTasks2);
					setIsDataReady(true);
					setIsFinish(false);
				}
			} catch (error) {
				console.error("Error in fetchData:", error);
				await handleTableErrors();
				setTotalRecords(0);
				setRowCount(0);
				setTableData([]);
				setIsDataReady(true);
				setIsFinish(false);
			} finally {
				setIsFinish(false);
			}
		}
		fetchData();
	}, [fetchFlag, serverCurrentPage, serverPageSize, searchParams, sortField, sortDirection]);

	const parseIfJson = (data) => {
		try {
			return JSON.parse(data);
		} catch (e) {
			return data; // Return original value if it's not valid JSON
		}
	};

	const handleContinue = async (index) => {
		var pendingTaskRecord = await db.pending_tasks.get(index);
		var formData = JSON.parse(pendingTaskRecord.pendingTasks).formData;

		formData.index = index;
		//await db.table("temp_form_data").clear();
		await db.current_workflow_step.add({ currentWorkflowStep: JSON.stringify(formData) });
		localStorage.setItem(Constants.CurrentWorkflowStep, true);

		if (formData.settings && formData.settings.data) {
			const parsedData = Object.fromEntries(Object.entries(formData.settings.data).map(([key, value]) => [key, parseIfJson(value)]));
			formData.settings.data = parsedData;
		}
		formData.executionId = JSON.parse(pendingTaskRecord.pendingTasks).executionId;
		navigate("/form_view_renderer?index=" + index, {
			state: { data: formData },
		});
	};

	const downloadPdf = async (renderId) => {
		if (renderId) {
			 window.open(renderId);
		}
	};


	const viewSummary = async (index) => {
		var pendingTaskRecord = await db.pending_tasks.get(index);
		var formData = JSON.parse(pendingTaskRecord.pendingTasks).formData;
		var summaryFormData = {};
		var dataHyperLink = null;
		if (formData.hyperLinkVariables) {
			dataHyperLink = JSON.parse(formData.hyperLinkVariables);
		}

		//JSON.parse(formData.hyperLinkVariables);
		if (dataHyperLink) {
			let form = await getFormById(dataHyperLink?.formKey, 1, dataHyperLink, true, 1);
			if (form.status === 0) {
				return;
			}
			formData = {
				...JSON.parse(form.data.formData),
			};

			navigate("/workflow-history-view", { state: { data: formData } });
		}
	};
	return (
		<>
			<div className="container">
				<PageTitle menuName={menuName} />
				{isFinish && <LoaderIcon />}
				<div className="row">
					<div className="col-12">
						<div className={`card ${UpliftCss.BodyBorder}`}>
							<div className="">
								<div className={`mb-3 ${UpliftCss.tableHeader}`}>
									{isDataReady && (
										<>
											{isMobile ? (
												// Mobile card view
												<div className="mobile-card-view">
													<SearchPanel
														onSearch={(filters) => {
															setSearchParams(filters);
															setServerCurrentPage(1); // Reset to first page when searching
															setFetchFlag((prev) => !prev);
														}}
														searchValues={searchValues}
														setSearchValues={setSearchValues}
													/>
													<CustomMobileCard
														tableData={tableData}
														columns={columns}
														onSort={handleSort}
														initialSortBy={[{ id: sortField, desc: sortDirection === "desc" }]}
														defaultSortField="created"
														defaultSortDirection="desc"
													></CustomMobileCard>

													<div className="mt-3">
														<AdvanceTableFooter
															rowCount={totalRecords}
															pageSize={serverPageSize}
															pageIndex={serverCurrentPage - 1}
															page={tableData}
															setPageSize={handleServerPagination}
															canPreviousPage={serverCurrentPage > 1}
															canNextPage={serverCurrentPage * serverPageSize < totalRecords}
															nextPage={handleNextPage}
															previousPage={handlePreviousPage}
															rowInfo
															navButtons
															rowsPerPageSelection
															rowsPerPageOptions={[5, 10, 15]}
															perPage={rowCount}
															jumpToPage={handleJumpToPage}
														/>
													</div>
												</div>
											) : (
												<AdvanceTableWrapper
													columns={columns}
													data={tableData}
													sortable
													pagination
													perPage={rowCount}
													onSort={handleSort}
													initialSortBy={[{ id: sortField, desc: sortDirection === "desc" }]}
													defaultSortField="created"
													defaultSortDirection="desc"
												>
													<SearchPanel
														onSearch={(filters) => {
															setSearchParams(filters);
															setServerCurrentPage(1); // Reset to first page when searching
															setFetchFlag((prev) => !prev);
														}}
														searchValues={searchValues}
														setSearchValues={setSearchValues}
													/>
													<AdvanceTable
														table
														headerClassName="bg-200 text-900 text-nowrap align-middle"
														rowClassName="align-middle white-space-nowrap"
														tableProps={{
															bordered: true,
															striped: true,
															className: "fs--1 mb-0 overflow-hidden",
														}}
													/>
													<div className="mt-3">
														<AdvanceTableFooter
															rowCount={totalRecords}
															pageSize={serverPageSize}
															pageIndex={serverCurrentPage - 1}
															page={tableData}
															setPageSize={handleServerPagination}
															canPreviousPage={serverCurrentPage > 1}
															canNextPage={serverCurrentPage * serverPageSize < totalRecords}
															nextPage={handleNextPage}
															previousPage={handlePreviousPage}
															rowInfo
															navButtons
															rowsPerPageSelection
															rowsPerPageOptions={[5, 10, 15]}
															perPage={rowCount}
															jumpToPage={handleJumpToPage}
														/>
													</div>
													{/* <div className="mt-3">
									<AdvanceTablePagination table />
								</div> */}
												</AdvanceTableWrapper>
											)}
										</>
									)}
								</div>
							</div>
						</div>
						<Modal isOpen={modal} backdrop={false} keyboard={true}>
							<ModalHeader toggle={toggle}>{t(em.delete_icon)} !!</ModalHeader>
							<ModalBody>
								{t(em.areyousuredelete)}
								<br />
								<br />
								<span style={{ color: "red", fontWeight: "bold" }}>{t(emanifestId)}</span>
							</ModalBody>
							<ModalFooter>
								<Button color="primary" onClick={() => handleDelete()}>
									{t(em.delete_icon)}
								</Button>
								<Button color="secondary" onClick={toggle}>
									{t(em.Cancel)}
								</Button>
							</ModalFooter>
						</Modal>
						<Modal isOpen={modalUnClaim} backdrop={false} keyboard={true}>
							<ModalHeader toggle={toggleUnClaim}>{t(em.unclaimTask)} !!</ModalHeader>
							<ModalBody>
								{t(em.areyousuretounclaim)}
								<br />
								<br />
								<span style={{ color: "red", fontWeight: "bold" }}>{t(emanifestId)}</span>
							</ModalBody>
							<ModalFooter>
								<Button color="primary" onClick={() => handleUnclaim()}>
									{t(em.unclaimTask)}
								</Button>
								<Button color="secondary" onClick={toggleUnClaim}>
									{t(em.Cancel)}
								</Button>
							</ModalFooter>
						</Modal>
					</div>
				</div>
			</div>
		</>
	);
}

export default GetWorkflowListByAssignee;
